import React, { useEffect, useMemo, useRef, useState } from 'react'

export default function BottomBenefitsSection({ promoBanners = [], loading = false, maxDots = 3 }) {
  const list = useMemo(() => (Array.isArray(promoBanners) ? promoBanners : []), [promoBanners])
  const count = list.length
  const showSkeleton = Boolean(loading) || count === 0

  const scrollerRef = useRef(null)
  const [active, setActive] = useState(0)
  const dotsCount = Math.min(count || 1, maxDots)

  useEffect(() => {
    setActive(0)
  }, [count, maxDots])

  useEffect(() => {
    const el = scrollerRef.current
    if (!el) return undefined

    const onScroll = () => {
      const w = el.clientWidth || 1
      const idx = Math.round(el.scrollLeft / w)
      setActive((prev) => {
        const next = Math.max(0, Math.min(idx, dotsCount - 1))
        return next === prev ? prev : next
      })
    }

    el.addEventListener('scroll', onScroll, { passive: true })
    return () => el.removeEventListener('scroll', onScroll)
  }, [dotsCount])

  const items = showSkeleton ? Array.from({ length: 1 }) : list.slice(0, maxDots)

  return (
    <div className="traffic-fine-benefits">
      <div className="traffic-fine-benefits-scroller" ref={scrollerRef}>
        {items.map((banner, i) => {
          const clickable = Boolean(banner?.bannerUrl)
          const key = banner?.systemPromoBannersId ?? i
          return (
            <div
              key={key}
              className={`traffic-fine-benefits-item ${showSkeleton ? 'is-skeleton' : ''} ${clickable ? 'is-clickable' : ''}`}
              onClick={() => {
                if (showSkeleton || !banner?.bannerUrl) return
                window.location.href = banner.bannerUrl
              }}>
              {showSkeleton ? (
                <div className="traffic-fine-skeleton-block" />
              ) : (
                <img src={banner?.bannerImageUrl || ''} alt="" loading="lazy" decoding="async" />
              )}
            </div>
          )
        })}
      </div>

      <div className="traffic-fine-benefits-dots">
        {showSkeleton ? (
          <div className="traffic-fine-skeleton-dot" />
        ) : (
          Array.from({ length: dotsCount }).map((_, i) => <div key={i} className={`traffic-fine-benefits-dot ${i === active ? 'is-active' : ''}`} />)
        )}
      </div>
    </div>
  )
}
